import { createContext, useContext, useEffect, useReducer, useState } from "react";
import * as apiSettings from "../api/apiSettings";
import { SetSettingsReducerd } from "./reducer/SetSettingsReducer";
import { useToast} from "./ToastContext";
import { useTranslation } from "react-i18next";
import { useGlobal } from "./GlobalContext";

const SettingsContext = createContext();
export const useSettings = () => useContext(SettingsContext);

export const SettingsContextProvider = ({children}) => {
 
    const { showToast } = useToast()
    const { t } = useTranslation(['Settings', 'common']);
    const { g } = useGlobal();
    
    /** 
     * settings - реальні налаштування
     * localSettings - використовуються для стану форми на сторінці налаштування
     */
    const [ settings, setSettings ] = useState(null);
    const [ localSettings, dispatchLocalSettings ] = useReducer(SetSettingsReducerd, null);
    const [ isReady, setIsReady ] = useState(false);
  
    // Отримуємо параметри з сервреа 
    const getSettings = async () => {
        const resSetting = await apiSettings.getSettings();
        setSettings(resSetting);
        dispatchLocalSettings({type:'SET', settings:resSetting});
        setIsReady(true);
    }
 
    // Зберігаємо параметри localSettings
    const saveSettings = async () => {
        const resSetting = await apiSettings.setSettings(localSettings);
        resSetting
            ? showToast(t('messSaved'), 'success')
            : showToast(t('common:messError'),'danger');    
            
        if (resSetting) setSettings(localSettings);
    }

    // Повертає ID обраної локалізації
    const getLocaleFilterId = () => {
        const aLocales = localSettings?.site?.locales?.split(',');
        const langDef = localSettings?.DIRS?.langs?.find(lang=>lang.lang_prefix === aLocales[0]);
        const lang = localSettings?.DIRS?.langs?.find(lang=>lang.lang_prefix === g?.localeFilter);
        return lang?.ID || langDef?.ID || 1;
    }

    // ХУК - відстеження неіснуючих параметрів
    useEffect(()=>{
        
        // Якщо параметрів немає - отримуємо їх
        if (!settings) getSettings();
    }, [settings])

    return isReady 
        ? (<SettingsContext.Provider 
            value={{
                    settings, 
                    setSettings, 
                    saveSettings,
                    localSettings,
                    dispatchLocalSettings,
                    getLocaleFilterId}}>
            {children}
        </SettingsContext.Provider>)
        : (<span className="badge text-bg-primary m-2">Get Settings...</span>);
    

}